'use strict';
define([
    'angular',
    'modules/access/get-started-now/get-started-now.controller',
],function(angular, GetStartedNowController){
    var app = angular.module('access.get-started-now', []);
    app.controller('GetStartedNowController', GetStartedNowController);
    return app;
});